<script lang="ts">
    import { newUser } from "@utils/underhood/firebase"
    import Password from "@components/material/Password.svelte"
    import { viewPrivacyPolicy } from "./Authenticate.svelte"
    import { errorize } from "@utils/underhood/firebase-errors"
    import { clickEnter } from "@utils/directives/accessibility"
    import Button from "@components/button/Button.svelte"
    import FormInput from "./FormInput.svelte"

    export let name = ""
    export let email = ""
    export let password = ""
    export let privacyPolicy = false
    export let newsletter = false

    let registerPromise: ReturnType<typeof newUser> | undefined = undefined
    let registering = false
    let error = ""

    async function startRegister() {
        if (!privacyPolicy) {
            errorMessage = "You must agree to our privacy policy!"
            return
        }

        if (!/^[a-zA-Z]+ [a-zA-Z\s]+$/.exec(name)) {
            errorMessage = "Please enter first and last name, only characters and spaces."
            return
        }
        registerPromise = newUser(email, password, name, newsletter)
        registering = true
        try {
            await registerPromise
        } catch (err) {
            error = "" + err
        }
        registering = false
    }

    let errorMessage: string
    $: errorMessage = errorize(error)
</script>

<form class="auth-form form" on:submit|preventDefault={startRegister} class:loading={registering}>
    <formgroup>
        <!-- <label>Name</label> -->
        <FormInput placeholder="Name" type="text" bind:value={name} autocomplete="name" />
    </formgroup>

    <formgroup>
        <!-- <label>Email</label> -->
        <FormInput
            placeholder="Email address"
            type="email"
            bind:value={email}
            autocomplete="email"
        />
    </formgroup>

    <formgroup>
        <!-- <label>Password</label> -->
        <Password bind:value={password} autocomplete="new-password" />
    </formgroup>

    <formgroup class="check">
        <input id="privacy-policy-check" type="checkbox" bind:checked={privacyPolicy} /><label
            for="privacy-policy-check"
            >I have read and accept the <span
                class="link underline"
                role="link"
                tabindex={0}
                on:keydown={clickEnter}
                on:click|preventDefault={() => {
                    viewPrivacyPolicy()
                }}>privacy policy & terms of use</span
            > (we will send you emails only to do with important logistics of the app).</label
        >
    </formgroup>

    <formgroup class="check">
        <input id="newsletter-check" type="checkbox" bind:checked={newsletter} /><label
            for="newsletter-check"
            >I would like to join the Circle of Atonement’s mailing list and receive weekly
            newsletters.</label
        >
    </formgroup>

    <formgroup class="submit-row">
        <Button type="submit" color="purple" loading={registering} disabled={registering} fullwidth>
            Create account
        </Button>
    </formgroup>

    {#if errorMessage}
        <error>
            {errorMessage}
        </error>
    {/if}
</form>

<style>
    .auth-form {
        display: grid;
        gap: 0.85rem;
    }

    .check {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        color: var(--color-grey-600);
        font-size: 0.9rem;
        line-height: 1.45;
    }

    input[type="checkbox"] {
        margin: 0.3rem;
        flex-shrink: 0;
        accent-color: var(--color-purple-700);
    }

    .submit-row {
        margin-top: 1.25rem;
    }

    :global(.darkmode) .check {
        color: var(--color-grey-200);
    }
</style>
